import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWebsiteinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinecap: "square",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 11
		}), /* @__PURE__ */ _jsx("path", { d: "M2 15h20M2 9h20M11 2C9.191 4.157 8 7.83 8 12s1.191 7.843 3 10m2-20c1.809 2.157 3 5.83 3 10s-1.191 7.843-3 10" })]
	})
});
export default SvgWebsiteinline;
